<template>
  <div id="booking-form">
    <main class="">
    <section class="bg-primary h-50vh md:h-70vh w-full pt-4 relative pb-8 main-hero  bg-cover bg-center bg-no-repeat pt-6 md:pt-12 pb-8 md:pb-20" :style="imgBack">


       <div class="max-w-screen-2xl mx-auto px-4 flex relative flex-col flex-wrap justify-between h-full ">
          <div class=" w-full">
            <LogoHeader />
          </div>
          <div class="w-full ">
            <h1 class="md:w-6/12 text-white font-secondary leading-tight text-4xl md:text-5-6xl font-normal md:pr-16 mb-3 text-left">{{tr("Booking Form")}}</h1>
            <p class="text-white font-light text-lg md:text-1/3xl" v-html="paxName"></p>
          </div>

       </div>
    </section>
    <section class="py-8 md:py-12" v-if="ready">
      <form class="w-full" action=""  ref="myForm">
        <div class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966]">
          <div class="w-full">
            <h2 class="font-secondary text-2xl md:text-3xl mb-8">
            {{tr("Contact")}}
            </h2>
          </div>
          <div class="w-full grid md:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-4 items-end">
            <div class="mb-5">
              <label  class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Reservation Name")}}<span class="ml-2 text-primary">*</span></label>
              <input type="text" :class="{'error': contactErrors.name}" v-model="contact.name" 
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent  outline-none block w-full p-3 " />
            </div>

            <div class="mb-5">
              <label  class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Address")}}<span class="ml-2 text-primary">*</span></label>
              <input type="text" :class="{'error': contactErrors.address}" v-model="contact.address" 
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3 "  />
            </div>

            <div class="mb-5">
              <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("ZIP CODE")}}<span class="ml-2 text-primary">*</span></label>
              <input type="text"  :class="{'error': contactErrors.zipcode}" v-model="contact.zipcode" 
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3 " />
            </div>

             <div class="mb-5">
              <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Nationality")}}<span class="ml-2 text-primary">*</span></label>
              <select id="countries"  :class="{'error': contactErrors.nationality}"  v-model="contact.nationality"
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3">
                <option v-for="(c, i) of countriesJSON" :key="i" :value="c.alpha2" :selected="c.alpha2 == contact.nationality"> {{ c.name }}</option>
              </select>
            </div>

            <div class="mb-5">
              <label  class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Cellphone")}}</label>
              <input type="number" v-model="contact.mobile" 
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent  outline-none block w-full p-3 " />
            </div>

            <div class="mb-5">
              <label  class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Email")}}<span class="ml-2 text-primary">*</span></label>
              <input type="email" :class="{'error': contactErrors.email}" v-model="contact.email" 
                class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3 "  />
            </div>

            <div class="mb-5 sm:col-span-2">
              <p class="text-primary text-sm">{{tr("Y_WILL_")}}</p>

            </div>
          </div>


        </div>

        <div class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966] mt-2 md:mt-4">
          <div class="w-full">
            <h2 class="font-secondary text-2xl md:text-3xl mb-8">
            {{tr("Travelers")}}
            </h2>
          </div>
          <div v-for="(pax, j) of passengers" :key="'pax-' + j" class="mb-8">
            <BookingFormPax 
              :passenger="passengers[j]" 
              @updateData="updatePax" 
              :errors="paxErrors[j]" 
              :paxNumber="j"
              :isDisabled="passengers[j].isExistingRecord"
              :paxList="passengersList"
              :isGroup="isGroup"
            >
            </BookingFormPax>
            <div class="w-full text-right trash mt-3" @click="passengers.splice(j, 1)" v-if="j>0 && !passengers[j].isExistingRecord">
              X
            </div>
          </div>
          <div class="mb-5 sm:col-span-4 mt-5">
            <button
              class="py-2 px-4 border cursor-pointer border-orange-500 rounded-md text-base font-bold bg-orange-500 text-white hover:bg-orange-600 transition-all"
              @click.prevent="addPax"
            >
              + {{tr("Add Traveler")}}
            </button>
          </div>

        </div>

        <div class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966] mt-2 md:mt-4">
          <div class="w-full">
            <h2 class="font-secondary text-2xl md:text-3xl mb-8">
            {{tr("International Flights")}} <span class="font-light font-primary text-1/2xl md:text-2xl">({{tr("Booked on your own")}})</span>
            </h2>
          </div>
          <div v-for="(f, j) of internationalFlights" :key="'flightI-' + j" class="w-full mb-8">
            <BookingFormFlight :flight="internationalFlights[j]" @update="updateFlightInternational($event, j)"></BookingFormFlight>
            <div class="w-full text-right trash mt-3" @click="internationalFlights.splice(j, 1)" v-if="j>0">
              X
            </div>
          </div>

          <div class="mb-5 sm:col-span-2 mt-5">
            <button class="py-2 px-4 border cursor-pointer border-primary rounded-md text-sm text-primary hover:bg-primary hover:text-white" @click.prevent="addFlightInternational">+ {{tr("Add Flight")}}</button>
          </div>
        </div>

        <div class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966] mt-2 md:mt-4">
          <div class="w-full">
            <h2 class="font-secondary text-2xl md:text-3xl mb-8">
            {{tr("Domestic Flights")}} <span class="font-light font-primary text-1/2xl md:text-2xl">({{tr("Booked on your own")}})</span>
            </h2>
          </div>
          <div v-for="(f, j) of domesticFlights" :key="'flightD-' + j" class="w-full mb-8">
            <BookingFormFlight :flight="domesticFlights[j]" @update="updateFlightDomestict($event, j)"></BookingFormFlight>
            <div class="w-full text-right trash mt-3" @click="domesticFlights.splice(j, 1)" v-if="j>0">
              X
            </div>
          </div>

          <div class="mb-5 sm:col-span-2 mt-5">
            <button class="py-2 px-4 border cursor-pointer border-primary rounded-md text-sm text-primary hover:bg-primary hover:text-white" @click.prevent="addFlightDomestict">+ {{tr("Add Flight")}}</button>
          </div>
        </div>

        <div class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966]">
          <div class="w-full">
            <h2 class="font-secondary text-2xl md:text-3xl mb-8">
            {{tr("Rooms Information")}}
            </h2>
          </div>
          <div v-for="(f, j) of rooms" :key="'room-' + j" class="w-full">
            <BookingFormRoom :room="rooms[j]" @update="updateRoom($event, j)"></BookingFormRoom>
          </div>

          <div class="mb-5 sm:col-span-3 mt-5">
            <button class="py-2 px-4 border cursor-pointer border-primary rounded-md text-sm text-primary hover:bg-primary hover:text-white" @click.prevent="addRoom">+ {{tr("Add Room")}}</button>
          </div>
        </div>
        
        <div class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966]">
          <div class="w-full mb-2">
            *{{tr("suggested_hotels_text")}}
          </div>
          <div class="w-full flex flex-row">
            <div class="basis-2/3">
              <textarea v-model="SuggestedHotels" rows="4" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block p-3 w-full"></textarea>
            </div>
            <div class="basis-1/3 flex justify-center items-center">
              <a
                v-if="lang != 'DE'"
                class="justify-self-center font-light border border-dark bg-white text-md py-2 px-4 hover:bg-primary hover:text-dark transition-all hover:border-primary rounded-lg text-center cursor-pointer"
                @click="viewHotels"
                >{{ tr("View") }} <template v-if="!hidePrices">{{ category }}</template> {{ tr("Hotels") }}
              </a>
              <a
                v-else
                class="justify-self-center font-light border border-dark bg-white text-md py-2 px-4 hover:bg-primary hover:text-dark transition-all hover:border-primary rounded-lg text-center cursor-pointer"
                @click="viewHotels"
                > <template v-if="!hidePrices">{{ category }}</template> Hotels sehen</a
              >
            </div>
          </div>
        </div>

        <div class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 mt-2 md:mt-4">
          <div class="w-full">

           <div class="flex flex-wrap w-full md:w-1/3 mx-auto items-center justify-center font-normal text-md">
              
              <label for="link-checkbox" class="ms-2 ">
                <input v-model="accept" id="link-checkbox" type="checkbox" value="" class="w-4 h-4 text-black mr-2">
                  {{tr("I have read and accept the")}}
                  <p class="underline font-bold uppercase" v-if="custom == 'YOU'">{{tr("terms and conditions")}}</p>
                  <a v-else href="https://sayhueque.com/terms-conditions/" target="_blank" class="underline font-bold uppercase">{{tr("terms and conditions")}}</a>.
              </label>

              <button :class="{'disabled': !accept}" @click.prevent="send" :disabled="!accept || sending"
                class="bg-primary py-2 px-4 w-full hover:bg-dark transition-all rounded-md mt-8 text-white font-semibold text-lg">{{tr("Send")}}</button>
              <div class="text-green-500" v-if="succesMessage">{{ tr("_FormText") }}</div>
              <div class="text-red-500" v-if="dangerMessage">{{ dangerMessage }}</div>
            </div>
            <br>
            <p v-if="dangerMessage">*{{ tr('_warning_error_booking_form') }}</p>
            <p>*{{ tr('Please note that the information you provide cannot be modified online. If you enter any incorrect details, you must contact your travel agent to request changes') }}</p>
        
          </div>
        </div>


      </form>
    </section>



  </main>

    <Footer></Footer>
    <Transition>
        <BlockUI v-if="loading"></BlockUI>
    </Transition>
  </div>
</template>

<script>
import * as _ from 'lodash';

import BlockUI from '@/components/tools/BlockUI.vue';
import Footer from '@/components/tools/Footer.vue';
import BookingFormPax from '@/components/bookingform/BookingFormPax.vue';
import BookingFormFlight from '@/components/bookingform/BookingFormFlight.vue';
import BookingFormRoom from '@/components/bookingform/BookingFormRoom.vue';
import LogoHeader from '@/components/tools/LogoHeader.vue';
import '@/assets/css/main.scss';
let countriesJSON = require(`@/assets/world.json`);
const api = window.api;

const moked_contact = {
    nationality: 'Argentina',
    zipcode: '10001',
    email: 'john.doe@example.com',
    address: '123 Main Street, New York, NY',
    name: 'John Doe',
    mobile: '1234567890'
};

const moked_pax = {
    name: 'John',
    lastName: 'Doe',
    DOB: '1990-01-15',
    gender: 'Male',
    nationality: 'Argentina',
    passport: 'US123456789',
    address: '123 Main Street, New York, NY',
    email: 'john.doe@example.com',
    mobile: '1234567890',
    tripReason: 'Vacation',
    allergies: 'None',
    medicalConditions: 'None',
    medication: 'None',
    medicalConditionsMedications: 'None',
    foodRestriction: 'None',
    hobbies:'Photography, Hiking',
    files: [],
    // passportExpirationDate: '2025-01-15'
};


const moked_international_flight = {
    airline: 'American Airlines',
    number: 'AA123',
    reservationCode: 'ABC123',
    departureDate: '2024-06-15',
    arrivalDate: '2024-06-15',
    departureCity: 'New York',
    arrivalCity: 'Buenos Aires',
    departureTime: '10:00',
    arrivalTime: '22:00'
};

const moked_domestic_flight = {
    airline: 'Aerolíneas Argentinas',
    number: 'AR456',
    reservationCode: 'XYZ789',
    departureDate: '2024-06-16',
    arrivalDate: '2024-06-16',
    departureCity: 'Buenos Aires',
    arrivalCity: 'Bariloche',
    departureTime: '08:00',
    arrivalTime: '10:30'
};


export default {
  name: 'BookingFrom',
  data() {
    return {
      loading: false,
      accept: false,
      sending: false,
      imgBack: null,
      ready: true,
      SuggestedHotels: '',
      countriesJSON: countriesJSON,
      contact: {
        nationality: '',
        zipcode: '',
        email: '',
        address: '',
        name: '',
        mobile: ''
      },
      passengers: [],
      internationalFlights: [],
      domesticFlights: [],
      rooms: [],
      trySend: false,
      pax: {
        selected: '',
        name: '',
        lastName: '',
        DOB: '',
        gender: '',
        nationality: '',
        passport: '',
        passportExpirationDate: '',
        address: '',
        email: '',
        mobile: '',
        tripReason: '',
        allergies: '',
        medicalConditions: '',
        medication: '',
        medicalConditionsMedications: '',
        foodRestriction: '',
        hobbies: '',
        files: [],
        isExistingRecord: false,
        paxId: null
      },
      flight: {
        airline: '',
        number: '',
        reservationCode: '',
        departureDate: '',
        arrivalDate: '',
        departureCity: '',
        arrivalCity: '',
        departureTime: '',
        arrivalTime: ''
      },
      room: {
        type: '',
        names: '',
      },
      paxRequired: ['selected', 'name', 'lastName', 'DOB', 'passport', 'passportExpirationDate', 'nationality', 'email', 'mobile'],
      contactRequired: ['name', 'address', 'email', 'nationality', 'zipcode'],
      paxErrors: {},
      contactErrors: {
        nationality: '',
        zipcode: '',
        email: '',
        address: '',
        name: '',
      },
      isNewRecord: true,
      user_code: '',
      succesMessage: false,
      dangerMessage: false,
      duplicatedNewPassengerIndexes: [],
    }
  },
  props: {
  },
  computed: {
    coverImg () {
      return this.$store.state.coverImg;
    },
    tripName () {
      return this.$store.state.tripName;
    },
    paxName () {
      return `${this.tr('For')} ${this.$store.state.paxName}`;
    },
    custom () {
      return this.$store.state.custom;
    },
    agent () {
      return this.$store.state.agent;
    },
    passengersList() {
      let passengers = this.$store.state.fitPrices?.map(p => p.PaxName);
      let selectedPassengers = this.passengers.filter(p => p.selected).map(p => p.selected);
      let passengersList = passengers.filter(p => selectedPassengers.indexOf(p) === -1);
      return passengersList;
    },
    isGroup () {
      let passengers = this.$store.state.fitPrices?.map(p => p.PaxName);
      return passengers.length > 12;
    },
    fitStatus () {
      return this.$store.state.fitStatus;
    },
    hotels () {
      return this.$store.state.hotels;
    },
    category () {
      if (this.hotels) {
        let rows = _.uniqBy(this.hotels, (r) => r.ClassCode);
        if (rows.length == 1 && rows[0].ClassName != 'Unassigned') {
          return rows[0].ClassName;
        }
      }
      return '';
    },
    lang () {
      return this.$store.state.lang;
    },
    hidePrices () {
      return this.$store.state.hidePrices
    },
  },
  async mounted() {
    this.fetchRecord();
    api.get('/api/tpsql/fit_client_image', this.$route.query, null, (result) => {
      this.$store.commit('setClientImage', result);
    });
    const fitBookingRes = await api.get('/api/tpsql/fit_booking', this.$route.query);
    this.$store.commit('setAgent', fitBookingRes?.[0]?.agent);

    this.ready = false;
    await Promise.resolve(import(`@/assets/img/fondoform.png`)).then((value) => {
      this.imgBack = {
        backgroundImage: "url(" + value.default + ")",
        //'align-items': 'center',
        //'background-attachment': 'fixed',
        //'background-position': 'center',
      };
    });
    if (!this.$route.query.Code) return;

    //this.passengers.push(Object.assign({}, this.pax));
    if (this.isNewRecord){
      this.addPax();
      this.domesticFlights.push(Object.assign({}, this.flight));
      this.internationalFlights.push(Object.assign({}, this.flight));
      this.rooms.push(Object.assign({}, this.room));
    }
    this.loading = true;
    api.get('/api/tpsql/trip_cover', this.$route.query, null, (result) => {
      this.$store.commit('setNames', result);
    });
    let url = '/api/tpsql/trip_seller_db';
    if (this.$route.query.bookingType == 'FIT') {
      url = '/api/tpsql/fit_seller_db';
    }
    let res = await api.get(url, this.$route.query);
    if (res) {
      this.$store.commit('setSeller', res);
      this.user_code = res.TourPlanUser;
    }
    let bookingInfo = await api.get('/api/tpsql/fit_booking', this.$route.query);
    if (bookingInfo) this.$store.commit('setFITBooking', bookingInfo);

    if (process.env.NODE_ENV === 'development') {
    // this.loadMockedData(); 
    }
    this.ready = true;
    this.loading = false;
    this.$store.commit('setQuery', this.$route.query);
  },
  methods: {
    loadMockedData () {
      this.contact = moked_contact
      this.passengers[0] = moked_pax;
      this.internationalFlights[0] = moked_international_flight;
      this.domesticFlights[0] = moked_domestic_flight;
      //this.rooms[0] = moked_room;
    },
    addPax () {
      this.paxErrors[this.passengers.length] = {};
      const newPax = Object.assign({}, this.pax);
      newPax.isExistingRecord = false; // Asegurarse de que nuevos pasajeros no estén marcados como existentes
      newPax.paxId = null;
      this.passengers.push(newPax);
      if (process.env.NODE_ENV === 'development') {
        //this.passengers[this.passengers.length-1] = {...moked_pax, isExistingRecord: false, paxId: null};
      }
    },
    tr(key) {
      return this.$root.tr(key);
    },
    addFlightInternational () {
      this.internationalFlights.push(Object.assign({}, this.flight))
    },
    addFlightDomestict () {
      this.domesticFlights.push(Object.assign({}, this.flight))
    },
    addRoom () {
      this.rooms.push(Object.assign({}, this.room))
    },
    updatePax (event, paxNumber) {
      this.passengers[paxNumber] = Object.assign({}, event);
      this.check();
    },
    updateFlightDomestict (event, j) {
      this.domesticFlights[j] = Object.assign({}, event);
    },
    updateFlightInternational (event, j) {
      this.internationalFlights[j] = Object.assign({}, event);
    },
    updateRoom (event, j) {
      this.rooms[j] = Object.assign({}, event);
    },
    async send () {
      this.trySend = true;
      this.dangerMessage = false;
      let totalSize = 0;
      let maxTotalSize = 10 * 1024 * 1024;
      this.passengers.forEach((passenger) => {
        if (passenger.files && passenger.files.length) {
          Array.from(passenger.files).forEach((photo) => {
            if (photo && photo.size) {
              totalSize += photo.size;
            }
          });
        }
      });
      if (totalSize > maxTotalSize) {
        this.dangerMessage = this.tr('SIZE_LIMIT_EXCEEDED');
        return;
      }
      if (!this.check()) {
        if (!this.dangerMessage) {
          this.dangerMessage = 'Complete fields required';
        }
        return;
      }

      if (this.duplicatedNewPassengerIndexes.length) {
        const duplicateDOBMessage = this.tr('Duplicate passengers detected with the same date of birth. Please review the information to proceed.') + ' ' + this.tr("Do you want to continue anyway?");
        const continueWithDuplicateDOB = confirm(duplicateDOBMessage);
        if (!continueWithDuplicateDOB) {
          this.duplicatedNewPassengerIndexes.forEach((idx) => {
            if (!this.paxErrors[idx]) this.paxErrors[idx] = {};
            this.paxErrors[idx].DOB = true;
          });
          this.paxErrors = Object.assign({}, this.paxErrors);
          this.dangerMessage = this.tr('Duplicate passengers detected with the same date of birth. Please review the information to proceed.');
          return;
        }
      }
      
      const formData = new FormData();

      for (let key in this.contact) {
          formData.append(`contact[${key}]`, this.contact[key]);
      }

      this.passengers.forEach((passenger, pIndex) => {
        for (let key in this.pax) {
          if (key == 'files' || key == 'isExistingRecord' || key == 'paxId') continue;
          formData.append(`passengers[${pIndex}][${key}]`, passenger[key]);
        }
        
        if (passenger.isExistingRecord && passenger.paxId) {
          formData.append(`passengers[${pIndex}][id]`, passenger.paxId);
        }
        
        Array.from(passenger.files).forEach((photo, phIndex) => {
          if (photo) {
            formData.append(`passengers[${pIndex}][passportPhotos][${phIndex}]`, photo);
          }
        });
      });

      this.internationalFlights.forEach((flight, fIndex) => {
        formData.append(`internationalFlights[${fIndex}][airline]`, flight.airline || '');
        formData.append(`internationalFlights[${fIndex}][FlightNumber]`, flight.number || '');
        formData.append(`internationalFlights[${fIndex}][ReservationCode]`, flight.reservationCode || '');
        formData.append(`internationalFlights[${fIndex}][DepartureDate]`, flight.departureDate || '');
        formData.append(`internationalFlights[${fIndex}][ArrivalDate]`, flight.arrivalDate || '');
        formData.append(`internationalFlights[${fIndex}][DepartureCity]`, flight.departureCity || '');
        formData.append(`internationalFlights[${fIndex}][ArrivalCity]`, flight.arrivalCity || '');
        formData.append(`internationalFlights[${fIndex}][DepartureTime]`, flight.departureTime || '');
        formData.append(`internationalFlights[${fIndex}][ArrivalTime]`, flight.arrivalTime || '');
        formData.append(`internationalFlights[${fIndex}][FlightType]`, 'INTERNATIONAL');
      });

      this.domesticFlights.forEach((flight, fIndex) => {
        formData.append(`domesticFlights[${fIndex}][airline]`, flight.airline || '');
        formData.append(`domesticFlights[${fIndex}][FlightNumber]`, flight.number || '');
        formData.append(`domesticFlights[${fIndex}][ReservationCode]`, flight.reservationCode || '');
        formData.append(`domesticFlights[${fIndex}][DepartureDate]`, flight.departureDate || '');
        formData.append(`domesticFlights[${fIndex}][ArrivalDate]`, flight.arrivalDate || '');
        formData.append(`domesticFlights[${fIndex}][DepartureCity]`, flight.departureCity || '');
        formData.append(`domesticFlights[${fIndex}][ArrivalCity]`, flight.arrivalCity || '');
        formData.append(`domesticFlights[${fIndex}][DepartureTime]`, flight.departureTime || '');
        formData.append(`domesticFlights[${fIndex}][ArrivalTime]`, flight.arrivalTime || '');
        formData.append(`domesticFlights[${fIndex}][FlightType]`, 'DOMESTIC');
      });

      formData.append('SuggestedHotels', this.SuggestedHotels || '');

      this.rooms.forEach((room, rIndex) => {
        for (let key in this.room) {
          formData.append(`rooms[${rIndex}][${key}]`, room[key]);
        }
      }); 

      let headers = {}
      this.succesMessage = false
      this.dangerMessage = false
      this.sending = true;
      const response = await api.post('/api/tpsql/bookingform/' + this.$route.query.Code + '/' + this.user_code, formData, headers, (error) => {
        this.dangerMessage = error;
      }); 
      this.sending = false;
      if (response) {
        this.succesMessage = true
        this.dangerMessage = false;
        //this.resetForm();
        this.fetchRecord();
      }
    },
    check () {
      if (!this.trySend) return true;
      let res = true;
      this.dangerMessage = false;
      this.duplicatedNewPassengerIndexes = [];
      for (let field of this.contactRequired) {
        if (!this.contact[field]) {
          res = false;
          this.contactErrors[field] = true;
        } else {
          this.contactErrors[field] = false;
        }
      }
      for (let i in this.passengers) {
        if (!this.paxErrors[i]) this.paxErrors[i] = {};
        for (let field of this.paxRequired) {
          if (!this.passengers[i][field]) {
            res = false;
            this.paxErrors[i][field] = true;
          } else {
            this.paxErrors[i][field] = false;
          }
        }
      }

      const dobMap = {};
      this.passengers.forEach((passenger, index) => {
        const dob = (passenger.DOB || '').trim();
        if (!dob) return;
        if (!dobMap[dob]) dobMap[dob] = [];
        dobMap[dob].push(index);
      });
      Object.values(dobMap).forEach((indexes) => {
        if (indexes.length > 1) {
          const newPassengerIndexes = indexes.filter((idx) => !this.passengers[idx]?.paxId);
          if (!newPassengerIndexes.length) return;
          this.duplicatedNewPassengerIndexes.push(...newPassengerIndexes);
        }
      });

      if (this.duplicatedNewPassengerIndexes.length) {
        this.duplicatedNewPassengerIndexes = [...new Set(this.duplicatedNewPassengerIndexes)];
      }

      this.contactErrors = Object.assign({}, this.contactErrors);
      this.paxErrors = Object.assign({}, this.paxErrors);
      return res;
    },
    resetForm() {
      this.sending = false;
      this.contact = {
        nationality: '',
        zipcode: '',
        email: '',
        address: '',
        name: '',
        mobile: ''
      };

      this.passengers = [];
      this.internationalFlights = [];
      this.domesticFlights = [];
      this.rooms = [];

      this.contactErrors = {
        nationality: '',
        zipcode: '',
        email: '',
        address: '',
        name: '',
      };
      this.paxErrors = {};

      this.accept = false;
      this.trySend = false;

      if (this.$refs.myForm) {
        this.$refs.myForm.reset();
      }
    },
    async fetchRecord() {
      api.get('/api/tpsql/fit_prices', this.$route.query, null, (result) => {
        this.$store.commit('setFITPrices', result);
      });
      if (this.$route.query.Code) {
        this.record = null;
        this.record = await api.get(`/api/bookingform/byreference/${this.$route.query.Code}`, null);
        
        if (this.record) {
          this.isNewRecord = false;
          this.SuggestedHotels = this.record.SuggestedHotels || '';
          const processValue = (value) => {
            if (value === "None" || value === null) return '';
            return value || '';
          };
          
          this.contact = {
            name: processValue(this.record.PaxName),
            address: processValue(this.record.Address),
            zipcode: processValue(this.record.ZipCode),
            nationality: processValue(this.record.Nationality),
            mobile: processValue(this.record.Mobile),
            email: processValue(this.record.Email)
          };
          
          this.passengers = [];
          if (this.record.BookingFormPaxs && this.record.BookingFormPaxs.length) {
            this.record.BookingFormPaxs.forEach(pax => {
              this.passengers.push({
                selected: processValue(pax.Selected),
                name: processValue(pax.FirstName),
                lastName: processValue(pax.LastName),
                DOB: processValue(pax.DOB),
                gender: processValue(pax.Gender),
                nationality: processValue(pax.Nationality),
                passport: processValue(pax.Passport),
                passportExpirationDate: processValue(pax.PassportExpirationDate),
                address: processValue(pax.Address),
                email: processValue(pax.Email),
                mobile: processValue(pax.Mobile),
                tripReason: processValue(pax.TripReason),
                allergies: processValue(pax.Allergies),
                medicalConditions: processValue(pax.MedicalConditions),
                medication: processValue(pax.Medication),
                medicalConditionsMedications: processValue(pax.MedicalConditionsMedications),
                foodRestriction: processValue(pax.FoodRestriction),
                hobbies: processValue(pax.Hobbies),
                files: [],
                isExistingRecord: true,
                paxId: pax.id || null
              });
              this.paxErrors[this.passengers.length - 1] = {};
            });
          } else {
            this.addPax();
          }
          
          this.internationalFlights = [];
          this.domesticFlights = [];
          
          if (this.record.BookingFormFlights && this.record.BookingFormFlights.length) {
            
            this.record.BookingFormFlights.forEach(flight => {
              const flightData = {
                airline: processValue(flight.Airline),
                number: processValue(flight.FlightNumber),
                reservationCode: processValue(flight.ReservationCode),
                departureDate: processValue(flight.DepartureDate),
                arrivalDate: processValue(flight.ArrivalDate),
                departureCity: processValue(flight.DepartureCity),
                arrivalCity: processValue(flight.ArrivalCity),
                departureTime: processValue(flight.DepartureTime),
                arrivalTime: processValue(flight.ArrivalTime)
              };
              
              if (flight.FlightType === 'INTERNATIONAL') {
                this.internationalFlights.push(flightData);
              } else if (flight.FlightType === 'DOMESTIC') {
                this.domesticFlights.push(flightData);
              }
            });
          }
          
          if (this.internationalFlights.length === 0) {
            this.internationalFlights.push(Object.assign({}, this.flight));
          }
          
          if (this.domesticFlights.length === 0) {
            this.domesticFlights.push(Object.assign({}, this.flight));
          }
          
          this.rooms = [];
          if (this.record.BookingFormRooms && this.record.BookingFormRooms.length) {
            this.record.BookingFormRooms.forEach(room => {
              this.rooms.push({
                type: processValue(room.Type),
                names: processValue(room.Names)
              });
            });
          } else {
            this.rooms.push(Object.assign({}, this.room));
          }
          
        }
      }
    },
    viewHotels () {
      let params = this.$route.query;
      params.fit = 'true';
      let route = this.$router.resolve({ name: 'Hotels', params: params })
      route.href = route.href + '?' + new URLSearchParams(this.$route.query).toString();
      window.open(route.href, '_blank');
    },
  },
  components: {
    BlockUI,
    Footer,
    BookingFormPax,
    BookingFormFlight,
    BookingFormRoom,  
    LogoHeader
  }
}

</script>

<style scoped>
.disabled {
  cursor: not-allowed;
}
.disabled:hover {
  background-color: grey;
}
.error {
  border: 2px solid red;
}

.trash {
  cursor: pointer;
}


</style>
